import { CloudDownloadOutlined } from "@ant-design/icons";
import { Button, Popover } from "antd";
import { useEffect, useState } from "react";
import { CSVLink } from "react-csv";

let apiData = [];
export default function ExportButton({
  allowNumberOfPage,
  columns,
  dataSource = null,
  searchTableTotalPage = 0,
  searchTableQuery,
  searchTableFormData,
  setSearchTableFormData,
  filename,
  exportSort,
  exportButtonSetting,
  onClick,
}) {
  const today = new Date();
  const month = today.getMonth() + 1;
  const year = today.getFullYear();
  const date = today.getDate();
  const currentDate = year + "-" + month + "-" + date;

  const [csvLink, setCsvLink] = useState(null);
  const [loadData, setLoadData] = useState(false);
  const [csvcolumns, setCSVcolumns] = useState([]);
  const [exportData, setExportData] = useState([]);
  const [firstRender, setFirstRender] = useState(true);

  const handleExport = () => {
    if (dataSource !== null) {
      setFirstRender(false);
      apiData = [...apiData, ...dataSource];
      handleCSV();
    } else {
      setFirstRender(false);
    }
  };

  useEffect(() => {
    if (!firstRender && dataSource == undefined) {
      if (Object.entries(searchTableFormData).length > 0) {
        setSearchTableFormData((c) => ({
          ...c,
          order: exportSort.order,
          page: 1,
        }));
      } else {
        setSearchTableFormData((c) => ({
          ...c,
          page: 1,
        }));
      }
    }
  }, [firstRender]);

  useEffect(() => {
    if (
      !firstRender &&
      searchTableQuery.isRefetching == false &&
      dataSource == undefined
    ) {
      apiData = [...apiData, ...searchTableQuery.data];

      if (
        searchTableFormData.page < searchTableTotalPage &&
        searchTableQuery.isRefetching == false
      ) {
        if (Object.entries(searchTableFormData).length > 0) {
          setSearchTableFormData((c) => ({
            ...c,
            order: exportSort.order,
            page: c.page + 1,
          }));
        } else {
          setSearchTableFormData((c) => ({
            ...c,
            page: c.page + 1,
          }));
        }
      }
      if (
        searchTableFormData.page == searchTableTotalPage &&
        searchTableQuery.isRefetching == false
      ) {
        handleCSV();
      }
    }
  }, [searchTableQuery?.isRefetching]);

  const handleCSV = () => {
    ///////set columns
    let csvcolumns = [];
    columns.forEach((element) => {
      csvcolumns.push({ label: element.title, key: element.title });
    });
    setCSVcolumns(csvcolumns);

    ///////set Data
    const dataArray = [];
    apiData.forEach((apiDataItem) => {
      const dataObj = {};
      columns.forEach((element) => {
        dataObj[element.title] = element.render(apiDataItem);
      });

      dataArray.push(dataObj);
    });

    setExportData(dataArray);
  };

  useEffect(() => {
    if (!firstRender) {
      console.log("csv");
      csvLink?.link?.click();
      reset();
    }
    setLoadData(false);
  }, [exportData]);

  const reset = () => {
    apiData = [];
    setExportData([]);
    setCSVcolumns([]);
    setLoadData(false);
    setFirstRender(true);
  };
  // please narrow down your search filters
  if (allowNumberOfPage <= searchTableTotalPage) {
    return (
      <>
        <Popover
          content={`please narrow down your search filters (max ${allowNumberOfPage} pages)`}
        >
          <Button
            type="primary"
            icon={<CloudDownloadOutlined />}
            loading={loadData}
            disabled={allowNumberOfPage <= searchTableTotalPage}
            onClick={() => {
              onClick();
              setLoadData(true);
              handleExport();
            }}
            {...exportButtonSetting}
          >
            Export
          </Button>
        </Popover>
        <CSVLink
          ref={setCsvLink}
          data={exportData}
          filename={filename ? `${filename}_${currentDate}` : currentDate}
          target="_blank"
          columnss={csvcolumns}
        ></CSVLink>
      </>
    );
  }

  return (
    <>
      <Button
        type="primary"
        icon={<CloudDownloadOutlined />}
        loading={loadData}
        onClick={() => {
          setLoadData(true);
          handleExport();
        }}
        {...exportButtonSetting}
      >
        Export
      </Button>
      <CSVLink
        ref={setCsvLink}
        data={exportData}
        filename={filename ? `${filename}_${currentDate}` : currentDate}
        target="_blank"
        columnss={csvcolumns}
      ></CSVLink>
    </>
  );
}
